import React from "react";
const SPLCHierarchyView = ({ data, hierarchyData }) => {
  return (
    <div className="m-2 h-full p-1 pb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12 fontExpand">
        <div className="space-y-1">
          <div className="grid grid-cols-2 py-2 border-b border-gray-200">
            <label>Hierarchy Effective Date:</label>
            <div className="expandedData">
              {data?.officeHierarchyEffectiveDate === null ||
              data?.officeHierarchyEffectiveDate === "1970-01-01T00:00:00"
                ? null
                : data.officeHierarchyEffectiveDate
                ? new Date(
                    data.officeHierarchyEffectiveDate
                  ).toLocaleDateString()
                : null}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Branch Manager:</label>
            <div className="expandedData">{data?.branchManagerName}</div>
          </div>
        </div>
        <div className="space-y-1">
          <div className="grid grid-cols-2 py-2  border-b border-gray-200">
            <label>HR Business Partner:</label>
            <div className="expandedData">{data?.hrBusinessPartner}</div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Business Consultant:</label>
            <div className="expandedData">{data?.businessConsultantName}</div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 lg:gap-12 fontExpand">
        <div className="space-y-2 w-full">
          <div className="h-[30px]"></div>
          <div className="grid grid-cols-2  border-b border-gray-200">
            <label>Team Manager:</label>
            <div className="expandedData">
              {hierarchyData?.teamManagerEmployeeName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>District Manager:</label>
            <div className="expandedData">
              {hierarchyData?.districtManagerEmployeeName}
            </div>
          </div>
          <div className="grid grid-cols-2  border-b border-gray-200">
            <label>Director:</label>
            <div className="expandedData">
              {hierarchyData?.directorEmployeeName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Vice President:</label>
            <div className="expandedData">
              {hierarchyData?.vicePresidentEmployeeName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Senior Vice President:</label>
            <div className="expandedData">
              {hierarchyData?.seniorVicePresidentEmployeeName}
            </div>
          </div>
        </div>
        <div className="space-y-2 w-full">
          <div className="h-[30px]"></div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Team:</label>
            <div className="expandedData">
              {hierarchyData?.teamHierarchyName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>District:</label>
            <div className="expandedData">
              {hierarchyData?.districtHierarchyName}
            </div>
          </div>
          <div className="grid grid-cols-2  border-b border-gray-200">
            <label>State:</label>
            <div className="expandedData">
              {hierarchyData?.stateHierarchyName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Market:</label>
            <div className="expandedData">
              {hierarchyData?.marketHierarchyName}
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200">
            <label>Business Unit:</label>
            <div className="expandedData">
              {hierarchyData?.businessUnitHierarchyName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SPLCHierarchyView;
